import React from "react";
import {
  CATEGORIES_ORDER,
  CATEGORY_COLORS,
  getCategoryIndex,
} from "../../utils/categoryColors";
import EstrelaCategoria from "./EstrelaCategoria";
import "./index.css";

export default function TermometroCategoria({ categoriaAtual }) {
  var activeIndex = getCategoryIndex(categoriaAtual);
  var hasCategory = activeIndex >= 0;

  var frase = hasCategory
    ? "Quanto mais você cresce no programa, mais benefícios você ganha."
    : "Inicie sua jornada com uma compra na Leo Madeiras, para evoluir de categoria e aproveitar vantagens exclusivas em cada etapa.";

  return (
    <div className="termometro-container">
      <p className="termometro-frase">{frase}</p>
      <div className="termometro-bar-wrapper">
        <div className="termometro-bar">
          {CATEGORIES_ORDER.map(function (cat, i) {
            var isActive = i === activeIndex;
            var isReached = hasCategory && i === activeIndex;
            var color = cat === "MARFIM" ? "#C9A06B" : CATEGORY_COLORS[cat];

            return (
              <div key={cat} className="termometro-segment">
                <div className="termometro-icon-area">
                  {isActive && (
                    <EstrelaCategoria categoria={cat} size={32} />
                  )}
                </div>
                <div
                  className={
                    "termometro-fill" +
                    (i === 0 ? " termometro-fill-first" : "") +
                    (i === CATEGORIES_ORDER.length - 1
                      ? " termometro-fill-last"
                      : "")
                  }
                  style={{
                    backgroundColor: color,
                    opacity: isReached ? 1 : 0.3,
                  }}
                />
                <span
                  className="termometro-label"
                  style={{
                    fontWeight: isActive ? 700 : 400,
                    opacity: isReached ? 1 : 0.5,
                  }}
                >
                  {cat}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
